export const YEARS: string[] = ['2018', '2019', '2020', '2021', '2022', '2023'];
